<template>
    <div class="my_account my_order">
        <Breadcrumb :breadcrumbs="breadcrumbs"></Breadcrumb>

        <section
            class="my_account_section manage_payment mt-0 pt-0 finance-checkout checkbox-hand"
        >
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="dashboard_design d-md-flex mb_82">
                            <div class="side_bar px-0 sidebar_desk">
                                <ul class="side_bar_links mt_2 p-0">
                                    <!-- start assign role for My Orders -->
                                    <li v-if="myOrders">
                                        <!-- <h1 style="color:green">{{ module_for_permission['0'].name }}</h1> -->
                                        <router-link
                                            :to="{ name: 'Myorder' }"
                                            :class="
                                                $route.meta.activeTab ==
                                                    'myorder' ||
                                                $route.meta.activeTab ==
                                                    'orderdetail'
                                                    ? 'active'
                                                    : ''
                                            "
                                        >
                                            <img
                                                src="/maincss/images/myorder.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />My Orders
                                        </router-link>
                                    </li>
                                    <!-- <li v-if="myBuild">
                                        <router-link
                                            :to="{ name: 'BuildListV3' }"
                                        >
                                            <img
                                                src="/maincss/images/myorder.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />
                                            My Builds
                                        </router-link>
                                    </li> -->
                                    <!-- end assign role for My Orders -->
                                    <!-- start assign role for My Saved Designs -->
                                    <li v-if="savedDesigns">
                                        <router-link
                                            :to="{ name: 'MyDesign' }"
                                            :class="
                                                $route.meta.activeTab ==
                                                'my-design'
                                                    ? 'active'
                                                    : ''
                                            "
                                        >
                                            <img
                                                src="/maincss/images/saved_design.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />My Designs
                                        </router-link>
                                    </li>
                                    <!-- start assign role for My Uploaded Images -->
                                    <li v-if="uploadedImages">
                                        <router-link
                                            :to="{ name: 'UploadImages' }"
                                            :class="
                                                $route.meta.activeTab ==
                                                'upload-images'
                                                    ? 'active'
                                                    : ''
                                            "
                                        >
                                            <img
                                                src="/maincss/images/upload_img.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />My Uploads
                                        </router-link>
                                    </li>
                                    <!-- start assign role for Payment Options -->
                                    <li v-if="paymentOptions">
                                        <router-link
                                            :to="{ name: 'ManagePayment' }"
                                            :class="
                                                $route.meta.activeTab ==
                                                'managepayment'
                                                    ? 'active'
                                                    : ''
                                            "
                                        >
                                            <img
                                                src="/maincss/images/payement.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Payment Options
                                        </router-link>
                                    </li>
                                    <!-- end assign role for Payment Options-->
                                    <!-- start assign role for Favorite -->
                                    <li v-if="favorite">
                                        <router-link
                                            :to="{ name: 'Favorite' }"
                                            :class="
                                                $route.meta.activeTab ==
                                                'favorite'
                                                    ? 'active'
                                                    : ''
                                            "
                                        >
                                            <img
                                                src="/maincss/images/fav.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Favorite
                                        </router-link>
                                    </li>

                                    <!-- end Favorite-->
                                    <!-- start assign role for Edit Profile -->
                                    <li v-if="editProfile">
                                        <router-link
                                            :to="{ path: 'edit-profile' }"
                                            :class="
                                                $route.meta.activeTab ==
                                                'editprofile'
                                                    ? 'active'
                                                    : ''
                                            "
                                        >
                                            <img
                                                src="/maincss/images/edit_profile.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Edit Profile
                                        </router-link>
                                    </li>

                                    <li>
                                        <router-link
                                            :to="{ name: 'PatchInventory' }"
                                            :class="
                                                $route.meta.activeTab ==
                                                'patchinventory'
                                                    ? 'active'
                                                    : ''
                                            "
                                        >
                                            <img
                                                src="/maincss/images/saved_design.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Patch Inventory
                                        </router-link>
                                    </li>

                                    <li v-if="myAddresses">
                                        <router-link
                                            :to="{ path: 'my-addresses' }"
                                            :class="
                                                $route.meta.activeTab ==
                                                'myaddresses'
                                                    ? 'active'
                                                    : ''
                                            "
                                        >
                                            <img
                                                src="/maincss/images/edit_profile.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />My Addresses
                                        </router-link>
                                    </li>
                                    <li v-if="myStore">
                                        <router-link
                                            :to="{ name: 'MyStore' }"
                                            :class="
                                                $route.meta.activeTab ==
                                                'mystore'
                                                    ? 'active'
                                                    : ''
                                            "
                                        >
                                            <img
                                                src="/maincss/images/mystore.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />My Store
                                        </router-link>
                                    </li>

                                    <!-- end  My Store-->
                                    <!-- start assign role for Manage Player -->
                                    <li v-if="managePlayer">
                                        <router-link
                                            :to="{ name: 'ManagePlayer' }"
                                            :class="
                                                $route.meta.activeTab ==
                                                    'manageplayer' ||
                                                $route.meta.activeTab ==
                                                    'addnewplayer'
                                                    ? 'active'
                                                    : ''
                                            "
                                        >
                                            <img
                                                src="/maincss/images/manage_payment.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Manage Player
                                        </router-link>
                                    </li>

                                    <!-- end Manage Player -->
                                    <!-- start assign role for Manage Team -->
                                    <li v-if="manageTeam">
                                        <router-link
                                            :to="{ name: 'ManageTeam' }"
                                            :class="
                                                $route.meta.activeTab ==
                                                    'manageteam' ||
                                                $route.meta.activeTab ==
                                                    'createteam' ||
                                                $route.meta.activeTab ==
                                                    'teammember'
                                                    ? 'active'
                                                    : ''
                                            "
                                        >
                                            <img
                                                src="/maincss/images/manage_team.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Manage Team
                                        </router-link>
                                    </li>

                                    <!-- end Manage Team -->
                                    <li>
                                        <a
                                            href="javascript:void(0)"
                                            @click="logout"
                                            class
                                        >
                                            <img
                                                src="/maincss/images/logout.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Logout
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <!-- here define menu for mobile sidebar -->
                            <div class="sidebar_mobile">
                                <a class="dropdown-toggle" id="item2" href="#"
                                    >My Account</a
                                >
                                <div class="side_bar px-0">
                                    <ul
                                        id="submenu2"
                                        class="side_bar_links mt_2 p-0 dropdown"
                                    >
                                        <li v-if="myOrders">
                                            <router-link
                                                :to="{ name: 'Myorder' }"
                                                :class="
                                                    $route.meta.activeTab ==
                                                    'myorder'
                                                        ? 'active'
                                                        : ''
                                                "
                                            >
                                                <img
                                                    src="/maincss/images/myorder.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />My Orders
                                            </router-link>
                                        </li>
                                        <!-- <li v-if="myBuild">
                                            <router-link
                                                :to="{ name: 'BuildList' }"
                                            >
                                                <img
                                                    src="/maincss/images/myorder.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />
                                                My Builds
                                            </router-link>
                                        </li> -->
                                        <li v-if="savedDesigns">
                                            <router-link
                                                :to="{ name: 'MyDesign' }"
                                                :class="
                                                    $route.meta.activeTab ==
                                                    'my-design'
                                                        ? 'active'
                                                        : ''
                                                "
                                            >
                                                <img
                                                    src="/maincss/images/saved_design.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />My Designs
                                            </router-link>
                                        </li>
                                        <li v-if="uploadedImages">
                                            <router-link
                                                :to="{ name: 'UploadImages' }"
                                                :class="
                                                    $route.meta.activeTab ==
                                                    'upload-images'
                                                        ? 'active'
                                                        : ''
                                                "
                                            >
                                                <img
                                                    src="/maincss/images/upload_img.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Uploaded Images
                                            </router-link>
                                        </li>
                                        <li v-if="paymentOptions">
                                            <router-link
                                                :to="{ name: 'ManagePayment' }"
                                                :class="
                                                    $route.meta.activeTab ==
                                                    'managepayment'
                                                        ? 'active'
                                                        : ''
                                                "
                                            >
                                                <img
                                                    src="/maincss/images/payement.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Payment Options
                                            </router-link>
                                        </li>
                                        <li v-if="favorite">
                                            <router-link
                                                :to="{ name: 'Favorite' }"
                                                :class="
                                                    $route.meta.activeTab ==
                                                    'favorite'
                                                        ? 'active'
                                                        : ''
                                                "
                                            >
                                                <img
                                                    src="/maincss/images/fav.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Favorite
                                            </router-link>
                                        </li>
                                        <li v-if="editProfile">
                                            <router-link
                                                :to="{ path: 'edit-profile' }"
                                                :class="
                                                    $route.meta.activeTab ==
                                                    'editprofile'
                                                        ? 'active'
                                                        : ''
                                                "
                                            >
                                                <img
                                                    src="/maincss/images/edit_profile.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Edit Profile
                                            </router-link>
                                        </li>
                                        <li>
                                            <router-link
                                                :to="{ name: 'PatchInventory' }"
                                                :class="
                                                    $route.meta.activeTab ==
                                                    'patchinventory'
                                                        ? 'active'
                                                        : ''
                                                "
                                            >
                                                <img
                                                    src="/maincss/images/saved_design.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Patch Inventory
                                            </router-link>
                                        </li>
                                        <li v-if="myAddresses">
                                            <router-link
                                                :to="{ path: 'my-addresses' }"
                                                :class="
                                                    $route.meta.activeTab ==
                                                    'myaddresses'
                                                        ? 'active'
                                                        : ''
                                                "
                                            >
                                                <img
                                                    src="/maincss/images/edit_profile.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />My Addresses
                                            </router-link>
                                        </li>
                                        <li v-if="myStore">
                                            <router-link
                                                :to="{ name: 'MyStore' }"
                                                :class="
                                                    $route.meta.activeTab ==
                                                    'mystore'
                                                        ? 'active'
                                                        : ''
                                                "
                                            >
                                                <img
                                                    src="/maincss/images/mystore.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />My Store
                                            </router-link>
                                        </li>
                                        <li v-if="managePlayer">
                                            <router-link
                                                :to="{ name: 'ManagePlayer' }"
                                                :class="
                                                    $route.meta.activeTab ==
                                                    'manageplayer'
                                                        ? 'active'
                                                        : ''
                                                "
                                            >
                                                <img
                                                    src="/maincss/images/manage_payment.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Manage Player
                                            </router-link>
                                        </li>
                                        <li v-if="manageTeam">
                                            <router-link
                                                :to="{ name: 'ManageTeam' }"
                                                :class="
                                                    $route.meta.activeTab ==
                                                    'manageteam'
                                                        ? 'active'
                                                        : ''
                                                "
                                            >
                                                <img
                                                    src="/maincss/images/manage_team.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Manage Team
                                            </router-link>
                                        </li>
                                        <li>
                                            <a
                                                href="javascript:void(0)"
                                                @click="logout"
                                                class
                                            >
                                                <img
                                                    src="/maincss/images/logout.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Logout
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <router-view
                                :key="'nested-' + $route.path"
                            ></router-view>
                        </div>
                        <div
                            class="button_btm text-right mt-2 backtolisting"
                            v-if="$route.name == 'Order_detail'"
                        >
                            <router-link
                                :to="{ name: 'Myorder' }"
                                class="btn btn_orange bg_primary_orange text_white ml_20"
                            >
                                Back to listing
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="preloader" v-show="isBusy">
                    <div class="preloader-body">
                        <svg width="40" height="40" viewBox="0 0 40 40">
                            <polygon
                                class="rect"
                                points="0 0 0 40 40 40 40 0"
                            />
                        </svg>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import Vue from "vue";
import { LOGOUT } from "@/store/actions.type";
import ApiService from "@/common/api.service";
import JwtService from "@/common/jwt.service";
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";

export default {
    name: "MyAccount",
    data() {
        return {
            pageTitle: "MyAccount",
            isBusy: false,
            module_for_permission: [],
            myOrders: false,
            uploadedImages: false,
            savedDesigns: false,
            paymentOptions: false,
            favorite: false,
            editProfile: false,
            myAddresses: false,
            myStore: false,
            managePlayer: false,
            manageTeam: false,
            myBuild: false,
            breadcrumbs: []
        };
    },
    components: {
        Breadcrumb
    },

    mounted() {
        this.pageTitle = this.$route.meta.pageTitle
            ? this.$route.meta.pageTitle
            : "My Account";
        this.breadcrumbs = [{ name: this.pageTitle }];
    },
    computed: {
        ...mapGetters(["isAuthenticated", "tags", "currentUserClient"]),
        tag() {
            return this.$route.params.tag;
        }
    },
    created() {
        this.getUserProfileData();
    },
    methods: {
        toEditProfile() {
            console.log("clicked edit profile");
            this.isBusy = true;
            // this.$router.push({ path: "/editprofile" });
        },

        logout() {
            localStorage.removeItem("new_canvas_elements");
            var _this = this;
            this.$store.dispatch(LOGOUT).then(() => {
                _this.$toast.success("Logout Successfully.", {
                    position: "top-right"
                });
                _this.$root.$emit("update-cart");
                localStorage.removeItem("cart");
                this.$router.push({ path: "/" });
            });
        },
        // Get user profile data
        getUserProfileData() {
            if (JwtService.getToken()) {
                let getProfData = JwtService.getUserData();
                if (getProfData) {
                    this.singleRolePermission(getProfData);
                } else {
                    ApiService.setHeader();
                    ApiService.get("user-profile")
                        .then(({ data }) => {
                            this.singleRolePermission(data);
                        })
                        .catch((response) => {
                            console.log("error in user profiles", response);
                            Vue.$toast.error(
                                "Something went wrong, please reload the page",
                                {
                                    position: "top-right"
                                }
                            );
                            return false;
                        });
                }
            } else {
                Vue.$toast.error(
                    "Something went wrong, please reload the page",
                    {
                        position: "top-right"
                    }
                );
                return false;
            }
        },
        // getting role and permission of users
        singleRolePermission(data) {
            var _this = this;
            if (data) {
                _this.module_for_permission = JSON.parse(
                    data.user.RolePermission.permission_id
                )["6"];
                _this.module_for_permission.submodule_json.forEach(
                    (submodule) => {
                        // Debug: Check all submodules
                        console.log("Submodule:", submodule.name, "Full Permission:", submodule.permissions.full);
                        
                        if (
                            submodule.name == "My Orders" &&
                            submodule.permissions.full
                        ) {
                            _this.myOrders = true;
                        } else if (
                            submodule.name == "Uploaded Images" &&
                            submodule.permissions.full
                        ) {
                            _this.uploadedImages = true;
                        } else if (
                            submodule.name == "Saved Designs" &&
                            submodule.permissions.full
                        ) {
                            _this.savedDesigns = true;
                            console.log("Saved Designs permission found and enabled");
                        } else if (
                            submodule.name == "Payment Options" &&
                            submodule.permissions.full
                        ) {
                            _this.paymentOptions = true;
                        } else if (
                            submodule.name == "Favorite" &&
                            submodule.permissions.full
                        ) {
                            _this.favorite = true;
                        } else if (
                            submodule.name == "Edit Profile" &&
                            submodule.permissions.full
                        ) {
                            _this.editProfile = true;
                        }
                        if (
                            submodule.name == "My Addresses" &&
                            submodule.permissions.full
                        ) {
                            _this.myAddresses = true;
                        } else if (
                            submodule.name == "My Store" &&
                            submodule.permissions.full
                        ) {
                            _this.myStore = true;
                        } else if (
                            submodule.name == "Manage Player" &&
                            submodule.permissions.full
                        ) {
                            _this.managePlayer = true;
                        } else if (
                            submodule.name == "Manage Team" &&
                            submodule.permissions.full
                        ) {
                            _this.manageTeam = true;
                        } else if (
                            submodule.name == "My Build" &&
                            submodule.permissions.full
                        ) {
                            _this.myBuild = true;
                        }
                    }
                );
            } else {
                console.log("exception throw when user not login");
            }
        }
    }
};
</script>
<style>
.finance-checkout .dashboard_design .order_detail_left_panel .steps_card {
    padding: 40px 90px;
}
.finance-checkout
    .dashboard_design
    .order_detail_left_panel
    .steps_card
    .border {
    width: 93%;
    border-top: 1px solid #d5dbe4 !important;
    position: absolute;
    top: 11px;
    height: 0.5px;
    border-bottom: none !important;
}
.finance-checkout
    .dashboard_design
    .order_detail_left_panel
    .steps_card
    .wizard {
    display: flex !important;
    justify-content: space-between !important;
}
@media only screen and (max-width: 991px) {
    .finance-checkout
        .dashboard_design
        .order_detail_left_panel
        .steps_card
        .wizard {
        margin-top: 0px !important;
    }
}
.finance-checkout
    .dashboard_design
    .order_detail_left_panel
    .steps_card
    .wizard
    .field {
    z-index: 1;
}
.finance-checkout
    .dashboard_design
    .order_detail_left_panel
    .steps_card
    .wizard
    .field
    .circle {
    width: 15px;
    height: 15px;
    border-radius: 100%;
    border: 4px solid #2b2b2b;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #0079c1;
    font-size: 14px;
    line-height: 32px;
    background-color: #2b2b2b;
    cursor: pointer;
}
.finance-checkout
    .dashboard_design
    .order_detail_left_panel
    .steps_card
    .wizard
    .field
    .circle
    img {
    width: 16px;
}
.finance-checkout
    .dashboard_design
    .order_detail_left_panel
    .steps_card
    .wizard
    .field
    .circle.done {
    border: 2px solid #0079c1;
    background-color: #0079c1;
    width: 25px;
    height: 25px;
}
.finance-checkout
    .dashboard_design
    .order_detail_left_panel
    .steps_card
    .wizard
    .field
    .circle
    .checked-block {
    display: none;
}
.finance-checkout
    .dashboard_design
    .order_detail_left_panel
    .steps_card
    .wizard
    .field
    .circle.done
    .checked-block {
    display: block;
}
.finance-checkout
    .dashboard_design
    .order_detail_left_panel
    .steps_card
    .wizard
    .field
    h5 {
    font-size: 16px;
    color: #000;
    display: inline-block;
    position: relative;
    top: 35px;
    text-align: center !important;
    left: -50px;
}
.dashboard_design .select_option .vs__dropdown-menu li {
    word-break: break-word !important;
    white-space: inherit;
    line-height: 22px !important;
}
.finance-checkout
    .dashboard_design
    .order_detail_left_panel
    .steps_card
    .order-details-steps {
    padding-top: 0px;
} 
.finance-checkout .tooltip-content .tooltip-body{
    max-height: 180px;
    overflow-y: auto;
}
</style>

